import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import Ranking from "@/components/leaderboard/Ranking";
import TeamRanking from "@/components/leaderboard/TeamRanking";
import { useSuspenseQuery } from "@tanstack/react-query";
import { getCompetitionsRetrieveQueryOptions } from "@/api/generated/backendAPI";
import UnscoredNotice from "@/components/leaderboard/UnscoredNotice";
export const Route = createFileRoute(
  "/_layout/_auth/competitions/$licenseId/score"
)({
  loader: ({ context: { queryClient }, params }) => {
    return queryClient.ensureQueryData(
      getCompetitionsRetrieveQueryOptions(params.licenseId)
    );
  },
  component: CompetitionScore,
});

type View = "team" | "individual";

const tabStyle = (active: boolean) =>
  "px-4 py-2 text-[15px] border-b-2 bg-transparent rounded-none " +
  (active
    ? "border-subcolor text-darkcolor font-bold"
    : "border-transparent text-navcolor font-normal hover:opacity-70");

const EMPTY_MESSAGE = (
  <p className="mb-8">現在、リーダーボードに表示できる情報がありません。</p>
);

function CompetitionScore() {
  const { licenseId } = Route.useParams();
  const { data: competitionData } = useSuspenseQuery(
    getCompetitionsRetrieveQueryOptions(licenseId)
  );
  // チーム戦の開催回はチームの順位を先に見せる
  const [view, setView] = useState<View>("team");
  const hasTeams = competitionData.hasTeams;
  const ascending = Boolean(
    competitionData.licensedCompetition.evaluationMetrics
      .evaluationPointAscending
  );
  const list = ascending
    ? competitionData.rankedSubmissions
    : [...competitionData.rankedSubmissions].reverse();

  const individual =
    list.length === 0 ? (
      EMPTY_MESSAGE
    ) : (
      <Ranking
        rankingData={list}
        submissionType={competitionData.licensedCompetition.submissionType}
        showTeam={hasTeams}
      />
    );

  return (
    <>
      <h2 className="mt-4">リーダーボード</h2>
      <UnscoredNotice
        myScored={competitionData.myScored}
        myParticipantKind={competitionData.myParticipantKind}
        mySubmissions={competitionData.mySubmissions}
        ascending={ascending}
      />
      {/* <div className="flex items-center justify-center bg-slate-100 m-4 border border-slate-500 h-96">
      <p>グラフ</p>
    </div> */}
      {!hasTeams ? (
        individual
      ) : (
        <>
          <div className="flex gap-2 px-4 mt-2 border-b border-[#dbe1e6]">
            <button
              type="button"
              className={tabStyle(view === "team")}
              onClick={() => setView("team")}
            >
              チーム
            </button>
            <button
              type="button"
              className={tabStyle(view === "individual")}
              onClick={() => setView("individual")}
            >
              個人
            </button>
          </div>
          {view === "team" ? (
            competitionData.rankedTeams.length === 0 ? (
              EMPTY_MESSAGE
            ) : (
              <TeamRanking rankingData={competitionData.rankedTeams} />
            )
          ) : (
            individual
          )}
        </>
      )}
    </>
  );
}
